import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import "../styles/howTo.scss";
import { useDispatch } from "react-redux";
import { initAppBrowser } from "@actions/initApp";
import styled from "@emotion/styled";
import { FiArrowDown } from "react-icons/fi";
import DefaultCustomButton from "@modules/Components/DefaultCustomButton";
import { ClearedStyleRouterLink } from "@modules/Components";
import { defaultAction } from "@actions/defaultAction";
import { SHOW_YOU_TUBE_POPUP } from "@constants/actionTypes";
import ExpansionPanel from "@components/ExpansionPanel";
import { FaPlay } from "react-icons/fa";

const HeaderMain = styled.div`
  border-radius: 0px 0px 460px 0px;
  background-image: radial-gradient(
      circle at 100% 0,
      rgba(255, 255, 255, 0.14),
      rgba(255, 255, 255, 0) 57%
    ),
    linear-gradient(to bottom, #271763, #271763);
  position: relative;
  text-align: center;

  @media (max-width: 1275px) {
    border-radius: 0px 0px 360px 0px;
  }
  @media (max-width: 1100px) {
    border-radius: 0px 0px 200px 0px;
  }
  @media (max-width: 600px) {
    border-radius: 0px 0px 120px 0px;
  }
  @media (max-width: 400px) {
    border-radius: 0px 0px 90px 0px;
  }
`;

const Header = styled.h1`
  font-size: 72px;
  line-height: 1.25;
  text-align: center;
  color: #fff;
  max-width: 1287px;
  margin: 0 auto;
  padding-top: 100px;
  padding-bottom: 70px;

  @media (max-width: 1500px) {
    font-size: 66px;
  }
  @media (max-width: 1375px) {
    font-size: 60px;
    padding-bottom: 50px;
    max-width: 985px;
  }
  @media (max-width: 1100px) {
    max-width: 95%;
    font-size: 50px;
  }
  @media (max-width: 999px) {
    max-width: 85%;
  }
  @media (max-width: 728px) {
    max-width: 90%;
  }
  @media (max-width: 650px) {
    font-size: 40px;
  }
  @media (max-width: 400px) {
    font-size: 32px;
  }
`;

const HeaderColored = styled.span`
  font-style: italic;
  color: #ff9c1b;
`;

const HeaderP = styled.div`
  opacity: 0.8;
  font-size: 18px;
  line-height: 2;
  text-align: center;
  color: #fff;
  max-width: 944px;
  margin: 0 auto;
  @media (max-width: 1100px) {
    max-width: 95%;
    font-size: 16px;
  }
  @media (max-width: 999px) {
    max-width: 85%;
  }
  @media (max-width: 728px) {
    max-width: 90%;
  }
  @media (max-width: 400px) {
    font-size: 14px;
  }
`;

const AbsoluteImageLeft = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;

  @media (max-width: 1275px) {
    width: 250px;
    height: auto;
  }
  @media (max-width: 999px) {
    display: none;
  }
`;

const AbsoluteImageRight = styled.img`
  position: absolute;
  top: 0;
  right: 0;

  @media (max-width: 1275px) {
    width: 100px;
    height: auto;
  }
  @media (max-width: 999px) {
    display: none;
  }
`;

const CircleP = styled.div`
  width: 96px;
  height: 96px;
  box-shadow: 30px 30px 50px 0 rgba(31, 32, 33, 0.15);
  background-color: #ffffff;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  text-align: center;
  margin-top: 68px;
  cursor: pointer;
  bottom: -43px;

  @media (max-width: 999px) {
    margin-top: 0;
  }
`;

const Arrow = styled(FiArrowDown)`
  color: #777984;
  font-size: 26px;
  opacity: 0.8;
  position: absolute;
  bottom: 35%;
  right: 35%;
`;

const TopSection = styled.section`
  padding-top: 180px;
  padding-bottom: 100px;
`;
const BlueLine = styled.div`
  height: 3px;
  background-color: #12b2ea;
  width: 36px;
  margin: ${props => props.margin};

  @media (max-width: 1100px) {
    margin: 0 auto;
  }
`;

const ProcessDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px 1fr 50px 1fr 50px 1fr;
  margin-top: 100px;

  @media (max-width: 1300px) {
    margin-top: 75px;
  }
  @media (max-width: 1150px) {
    grid-template-columns: 1fr 1fr;
    width: 80%;
    grid-row-gap: 50px;
    margin-top: 55px;
  }
  @media (max-width: 767px) {
    width: auto;
  }
  @media (max-width: 630px) {
    grid-template-columns: 1fr;
  }
`;

const ProcessItem = styled.div`
  font-size: 18px;
  line-height: 1.67;
  text-align: center;
  color: #ffffff;
  text-align: center;

  @media (max-width: 1400px) {
    font-size: 17px;
  }
  @media (max-width: 1300px) {
    font-size: 16px;
  }
  @media (max-width: 1150px) {
    font-size: 18px;
    line-height: 1.67;
    max-width: 278px;
    margin: 0 auto;
  }
  @media (max-width: 630px) {
    margin-top: 31px;
  }
`;

const ProcessImageDiv = styled.div`
  width: 96px;
  height: 96px;
  box-shadow: 29px 29px 44px 0 rgba(31, 32, 33, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto;
`;

const ProcessText = styled.div`
  font-size: 16px;
  line-height: 1.88;
  text-align: center;
  color: #777984;
  max-width: 235px;
  margin: 0 auto;
`;

const ProcessTextHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.67;
  text-align: center;
  color: #1f2021;
  padding-top: 42px;
  padding-bottom: 16px;
`;

const SquiglyImageDiv = styled.div`
  position: relative;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const SquiglyImage = styled.img`
  position: absolute;
  left: -50px;
  top: 50px;
  @media (max-width: 1400px) {
    left: -37px;
    top: 38px;
    width: 129px;
  }
`;

const SquiglyImageInverted = styled.img`
  position: absolute;
  left: -50px;
  top: 11px;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(173deg);

  @media (max-width: 1400px) {
    left: -37px;
    width: 129px;
  }
`;

const MiddleSection = styled.section`
  box-shadow: 0 20px 80px 0 rgba(119, 121, 132, 0.1);
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
`;

const MiddleGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 84%;
  margin: 0 auto;
  grid-column-gap: 44px;
  align-items: center;

  @media (max-width: 1850px) {
    width: 88%;
  }
  @media (max-width: 1400px) {
    width: 92%;
    grid-column-gap: 36px;
  }
  @media (max-width: 1300px) {
    grid-template-columns: auto 1fr;
    max-width: 734px;
  }
  @media (max-width: 950px) {
    display: block;
    text-align: center;
  }
`;

const MiddleContent = styled.div`
  @media (max-width: 950px) {
    max-width: 400px;
    margin: 0 auto;
    margin-top: 30px;
  }
`;

const MiddleHeader = styled.div`
  font-size: 24px;
  line-height: 1.5;
  color: #1f2021;

  @media (max-width: 1765px) {
    font-size: 22px;
  }
`;

const MiddleText = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: #777984;
  max-width: 680px;

  @media (max-width: 1765px) {
    font-size: 15px;
  }
`;

const Button = styled.div`
  min-width: 229px;

  @media (max-width: 1300px) {
    grid-column: 1/4;
    margin: 0 auto;
    margin-top: 40px;
    width: 320px;
  }
  @media (max-width: 430px) {
    width: 100%;
  }
`;

const BorderBottom = styled.div`
  opacity: 0.15;
  background-image: linear-gradient(
    to right,
    rgba(66, 67, 69, 0.3),
    #1f2021 51%,
    rgba(31, 32, 33, 0.3)
  );
  width: 100%;
  height: 1px;
  grid-column: 1/4;
  margin-top: 46px;
  margin-bottom: 50px;
`;

const BottomSection = styled.section`
  display: grid;
  grid-template-columns: 1.4fr 1.5fr;
  grid-gap: 260px;
  padding-top: 80px;

  @media (max-width: 1650px) {
    grid-template-columns: 1.5fr 1.5fr;
    grid-gap: 189px;
  }
  @media (max-width: 1500px) {
    grid-gap: 153px;
  }
  @media (max-width: 1200px) {
    grid-gap: 83px;
  }
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    text-align: center;
    max-width: 700px;
    margin: 0 auto;
    padding-top: 0px;
  }
  @media (max-width: 500px) {
    max-width: 90%;
  }
`;

const VideoContainer = styled.div`
  position: relative;
  @media (max-width: 1100px) {
    grid-row: 2/3;
  }
`;

const BottomTextContainer = styled.div`
  padding-top: 160px;
  max-width: 445px;

  @media (max-width: 1500px) {
    padding-top: 100px;
  }
  @media (max-width: 1100px) {
    grid-row: 1/2;
    text-align: center;
    margin: 0 auto;
  }
`;

const BottomHeader = styled.h3`
  font-size: 36px;
  font-weight: 400;
  line-height: 1.44;
  color: #1f2021;
  padding-top: 36px;
  padding-bottom: 50px;

  @media (max-width: 1500px) {
    font-size: 32px;
    line-height: 1.3;
    padding-bottom: 40px;
  }
`;

const BottomText = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
`;

const AbsoluteVideoCoverImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 0px 460px 0px 0px;

  @media (max-width: 1700px) {
    border-radius: 0px 420px 0px 0px;
  }
  @media (max-width: 600px) {
    border-radius: 0px 100px 0px 0px;
  }
`;

const AbsoluteButtonContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const AbsoluteButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const Expanding = styled.div`
  position: absolute;
`;

const AbsoluteButton = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #ff9c1b;
  z-index: 1;
`;

const Triangle = styled(FaPlay)`
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  font-size: 22px;
`;

const TopHeader = styled.h2`
  font-size: 48px;
  line-height: 1.42;
  text-align: center;
  color: #1f2021;
  margin-top: 22px;

  @media (max-width: 600px) {
    font-size: 40px;
  }
  @media (max-width: 400px) {
    font-size: 32px;
  }
`;

const Faqs = styled.section`
  background-image: linear-gradient(
    to bottom,
    rgba(34, 176, 252, 0.081),
    rgba(34, 176, 252, 0)
  );
  position: relative;
  min-height: 920px;

  @media (max-width: 1300px) {
    min-height: 1165px;
  }
  @media (max-width: 950px) {
    min-height: 1316px;
  }
  @media (max-width: 545px) {
    min-height: 1360px;
  }
`;

const FaqContent = styled.div`
  width: fit-content;
  margin: 0 auto;
  padding-top: 180px;
  padding-bottom: 100px;

  @media (max-width: 950px) {
    width: 85%;
  }
  @media (max-width: 520px) {
    padding-top: 100px;
  }
`;

const BulkSeller = styled.div`
  box-shadow: 0 20px 80px 0 rgba(119, 121, 132, 0.1);
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
  position: absolute;
  margin: 0 auto;
  bottom: -102px;
  right: 0;
  left: 0;

  @media (max-width: 520px) {
    position: relative;
  }
`;

const FaqHeader = styled.h4`
  font-size: 36px;
  text-align: center;
  color: #1f2021;
  margin-top: 36px;
  margin-bottom: 60px;
`;

const LinkSpan = styled.span`
  cursor: pointer;
  color: #ff9c1b;
`;

const howItWorksArray = [
  {
    header: "Shop around",
    text: "Got something you need? Never shop again without checking",
    image: "https://cdn.cardcash.com/website/ui/howiw/cart.svg",
    link: "/buy-gift-cards/",
    linkText: "CardCash",
    afterLinkText: "!"
  },
  {
    header: "Find [gift] cards",
    text: "A quick search will net you the best savings!",
    image: "https://cdn.cardcash.com/website/ui/howiw/card-slides-icon.svg",
    link: "/buy-gift-cards/",
    linkText: "Browse",
    afterLinkText: " over 1300 brands for the highest discounts."
  },
  {
    header: "Save at checkout",
    text: "Use discounted gift cards to pay for everything you want, everywhere, all the time.",
    image: "https://cdn.cardcash.com/website/ui/howiw/savings-icon.svg"
  },
  {
    header: "Protect yourself",
    text: "Use your cards within",
    image: "https://cdn.cardcash.com/website/ui/howiw/support-icon-big.svg",
    link: "/guarantee/",
    linkText: "45 day guarantee",
    afterLinkText: " period for super safe savings."
  }
];

const middleSectionArray = [
  {
    image: "https://cdn.cardcash.com/website/ui/howiw/referAFriend.svg",
    header: "Refer a friend",
    text: "Because you’re not the type of friend who keeps great finds top secret, refer a friend to CardCash and you both receive $5. Just send them this link. Besties only 😄",
    button: "ORANGE_BUTTON",
    buttonText: "Get a link",
    link: "/refer/"
  }
];

const faqArray = [
  {
    id: 1,
    question: "Why do some gift cards go bad?",
    answer:
      "Unlike a carton of milk past its expiration date, gift cards do not go bad all by themselves. The two most common reasons gift cards lose their balance are:",
    list: [
      "The card was purchased with a stolen credit card and subsequently canceled by the issuing company.",
      "The original owner used the card number after selling it to CardCash."
    ]
  },
  {
    id: 2,
    question: "How can I protect myself?",
    answer:
      "These simple steps will keep you safe against unscrupulous sellers and fraudulently obtained gift cards",
    list: [
      "Check your gift card balance before going to the store.",
      "Use full balance of the card within 45 days of the purchase. Even if you checked the balance and it was fine within 45 days, the guarantee expires at 45 days from your purchase date.",
      "All you need to do is use the card within 45 days."
    ]
  },
  {
    id: 3,
    question: "What happens if I have questions that aren’t listed here?",
    answer: "Visit our FAQ page",
    link: "/faqs/",
    linkText: "here",
    afterLinkText: "."
  }
];

const HowTo = () => {
  const dispatch = useDispatch();
  const myRef = useRef(null);
  const [oneIsOpenend, changeOneIsOpenend] = useState(false);
  const [idOfOldItem, setIdOfOldItem] = useState();
  const [otherIsClicked, changeIsOtherClicked] = useState("");

  useEffect(() => {
    dispatch(initAppBrowser(["messages"]));
    window.scrollTo(0, 0);
  }, []);

  const handleCircleClick = () => {
    executeScroll();
  };

  const executeScroll = () => scrollToRef(myRef);

  const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop);

  const handleOtherClicked = id => {
    if (oneIsOpenend && idOfOldItem === id) {
      changeOneIsOpenend(false);
      setIdOfOldItem();
    } else {
      changeOneIsOpenend(true);
    }
    changeIsOtherClicked(id);
  };

  return (
    <div className="mar-t-128">
      <div>
        <Helmet
          title={"How to save with gift cards"}
          meta={[
            {
              name: "description",
              content:
                "Learn how to save safely with discounted gift cards from CardCash, the world's largest gift card exchange."
            }
          ]}
        />
        <HeaderMain>
          <AbsoluteImageLeft
            src="https://cdn.cardcash.com/home/images/other/element-background-group.svg"
            alt=""
          />
          <AbsoluteImageRight
            src="https://cdn.cardcash.com/website/ui/howiw/top-right-elements.svg"
            alt=""
          />

          <Header>
            Imagine what it feels like to save every.{" "}
            <HeaderColored>single.</HeaderColored> time. you shop?
          </Header>
          <HeaderP>
            Yes, they’re called “gift cards”, but they are really more like
            savings cards. Other people's gift cards are your way to save. We
            buy gift cards for less than their value from people just like you
            who don't want them, and resell them at a discount so you can save.
            So any time you’re about to purchase anything — online or in-store,
            at 1,300+ retailers — you can save with CardCash.
          </HeaderP>
          <CircleP onClick={handleCircleClick} ref={myRef}>
            <Arrow className="arrow" />
          </CircleP>
        </HeaderMain>

        <main>
          <TopSection>
            <BlueLine margin={"0 auto"} />
            <TopHeader className="main-container-page-width">
              How can you save on everything?
            </TopHeader>
            <ProcessDiv className="main-container-page-width">
              {howItWorksArray.map((item, index) => (
                <React.Fragment key={index}>
                  <ProcessItem>
                    <ProcessImageDiv className="process-image-div">
                      <img src={item.image} alt="" />
                    </ProcessImageDiv>
                    <ProcessTextHeader>{item.header}</ProcessTextHeader>
                    <ProcessText>
                      {item.text}
                      {item.link && (
                        <span>
                          <LinkSpan>
                            <ClearedStyleRouterLink to={item.link}>
                              &nbsp;{item.linkText}
                            </ClearedStyleRouterLink>
                          </LinkSpan>
                          {item.afterLinkText}
                        </span>
                      )}
                    </ProcessText>
                  </ProcessItem>
                  {index === 0 || index === 2 ? (
                    <SquiglyImageDiv>
                      <SquiglyImage
                        src="https://cdn.cardcash.com/website/ui/howiw/DottedLines.svg"
                        alt=""
                      />
                    </SquiglyImageDiv>
                  ) : index === 1 ? (
                    <SquiglyImageDiv>
                      <SquiglyImageInverted
                        src="https://cdn.cardcash.com/website/ui/howiw/DottedLines.svg"
                        alt=""
                      />
                    </SquiglyImageDiv>
                  ) : null}
                </React.Fragment>
              ))}
            </ProcessDiv>
          </TopSection>
          <MiddleSection className="main-container-page-width">
            {middleSectionArray.map((item, index) => (
              <MiddleGrid key={index}>
                <ProcessImageDiv>
                  <img src={item.image} alt="" />
                </ProcessImageDiv>
                <MiddleContent>
                  <MiddleHeader>{item.header}</MiddleHeader>
                  <MiddleText>{item.text}</MiddleText>
                </MiddleContent>
                <Button>
                  <ClearedStyleRouterLink to={item.link}>
                    <DefaultCustomButton
                      handleClick={f => f}
                      classes={"main-default-orange-button"}
                      type="button"
                      disabled={false}
                      buttonType={item.button}
                      name="submit"
                    >
                      <span>{item.buttonText}</span>
                    </DefaultCustomButton>
                  </ClearedStyleRouterLink>
                </Button>
                {index === 0 && middleSectionArray.length > 1 && (
                  <BorderBottom />
                )}
              </MiddleGrid>
            ))}
          </MiddleSection>
          <BottomSection>
            <VideoContainer>
              <AbsoluteVideoCoverImage
                src="https://cdn.cardcash.com/website/ui/howiw/VideoPoster.png"
                alt=""
              />
              <AbsoluteButtonContainer
                onClick={() =>
                  dispatch(defaultAction(SHOW_YOU_TUBE_POPUP, true))
                }
              >
                <AbsoluteButtonDiv>
                  <Expanding className="how-absolute-button-play" />

                  <AbsoluteButton>
                    <Triangle style={{ color: "#ffffff" }} />
                  </AbsoluteButton>
                </AbsoluteButtonDiv>
              </AbsoluteButtonContainer>
            </VideoContainer>
            <BottomTextContainer>
              <BlueLine />
              <BottomHeader>
                Right now, someone, somewhere, is searching for the gift card
                that’s sitting in your drawer
              </BottomHeader>
              <BottomText>
                Or your wallet. Or your pocket. Or the one you just got for
                Christmas. Turn it into cash quickly and easily by
                <LinkSpan>
                  <ClearedStyleRouterLink to={"/sell-gift-cards/"}>
                    &nbsp;selling it to us.
                  </ClearedStyleRouterLink>
                </LinkSpan>
              </BottomText>
            </BottomTextContainer>
          </BottomSection>
          <Faqs>
            <FaqContent>
              <BlueLine margin={"0 auto"} />
              <FaqHeader>Frequently asked questions</FaqHeader>
              {faqArray.map((item, index) => (
                <ExpansionPanel
                  header={"Frequently asked questions"}
                  key={item.id}
                  item={item}
                  handleOtherClicked={handleOtherClicked}
                  otherIsClicked={otherIsClicked}
                  currentHeader={"Frequently asked questions"}
                  oneIsOpenend={oneIsOpenend}
                  idOfOldItem={idOfOldItem}
                  setIdOfOldItem={setIdOfOldItem}
                />
              ))}
            </FaqContent>
            <BulkSeller className="main-container-page-width">
              <MiddleGrid>
                <ProcessImageDiv>
                  <img
                    src="https://cdn.cardcash.com/website/ui/howiw/bulk-icon.svg"
                    alt=""
                  />
                </ProcessImageDiv>
                <MiddleContent>
                  <MiddleHeader>Are you a bulk buyer?</MiddleHeader>
                  <MiddleText>
                    CardCash’s pre-owned gift cards have been saving buyers
                    money since 2008, and bulk buyers save even more! Start
                    saving today and never pay full price again.
                  </MiddleText>
                </MiddleContent>
                <Button>
                  <ClearedStyleRouterLink to={"/bulk-buy-gift-cards/"}>
                    <DefaultCustomButton
                      handleClick={f => f}
                      classes={"main-default-orange-button"}
                      type="button"
                      disabled={false}
                      buttonType={"ORANGE_BUTTON"}
                      name="submit"
                    >
                      <span>Learn more</span>
                    </DefaultCustomButton>
                  </ClearedStyleRouterLink>
                </Button>
              </MiddleGrid>
            </BulkSeller>
          </Faqs>
        </main>
      </div>
    </div>
  );
};

export default HowTo;
